// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__131mt","inputWrap":"styles_inputWrap__3M9iJ","input":"styles_input__2N2_p"};